module.exports = __webpack_public_path__ + "static/social-1-801b48ed8d2b046a05a53e715d8dfac6.png";